
export default function WhyChooseUs() {
  const features = [
    { icon: 'ri-star-line', text: 'Experienced and professional' },
    { icon: 'ri-hammer-line', text: 'High-quality craftsmanship' },
    { icon: 'ri-shield-check-line', text: 'Reliable and trustworthy' },
    { icon: 'ri-palette-line', text: 'Clean, modern designs' },
    { icon: 'ri-customer-service-2-line', text: 'Customer-focused service' },
    { icon: 'ri-file-list-3-line', text: 'Free estimates' }
  ];

  return (
    <section className="bg-white py-16 sm:py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#E8F1FF] opacity-20 rounded-full -translate-y-1/2 translate-x-1/3"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Image */}
          <div className="order-2 lg:order-1">
            <div className="w-full h-[300px] sm:h-[450px] lg:h-[600px] rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/57f8473043f72217489296d0396e9031.jpeg"
                alt="Premier Renovations Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-2 mb-4 sm:mb-6">
              <div className="w-2 h-2 rounded-full bg-[#0B1F3A]"></div>
              <span
                className="text-[#0B1F3A] text-xs font-semibold tracking-widest uppercase"
                style={{ fontFamily: 'Open Sans, sans-serif' }}
              >
                Why Premier Renovations
              </span>
            </div>
            <h2
              className="text-[#0B1F3A] text-3xl sm:text-4xl lg:text-5xl font-bold mb-8 sm:mb-12 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Built on Trust, Delivered with Excellence
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3 sm:gap-4">
                  {/* 
                    Tailwind’s arbitrary color syntax (e.g., bg-[#2D6CDF]/10) can cause parsing errors in some environments.
                    We replace it with a solid background color combined with bg-opacity-10 for the same visual effect.
                  */}
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#2D6CDF] bg-opacity-10 flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-[#2D6CDF] text-lg sm:text-xl`}></i>
                  </div>
                  <span
                    className="text-[#0B1F3A] text-base sm:text-lg font-medium"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {feature.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
